var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-body text-stone-700",attrs:{"id":"default-layout"}},[_c('TopContent'),_vm._v(" "),_c('Navbar'),_vm._v(" "),(!_vm.$slots.default)?_c('Nuxt'):_vm._e(),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('CookieBanner'),_vm._v(" "),_c('Footer')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }